module.exports = __webpack_public_path__ + "img/facebook.8c88f068.svg";